// @flow

export const pageActions = {
  set_page_name: 'set_page_name'
};

export const setPageName = (pageObj: Object) => ({
  type: pageActions.set_page_name,
  payload: pageObj
});
